export const getFile = (module: string, filePath: string) => {
  return '/api/image/' + module + '/' + filePath;
};
